import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import MenuLeftNav from "./MenuLeftNav";
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import asyncValidate from './asyncValidate';
import Divider from '@material-ui/core/Divider';
import { connect } from "react-redux";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import * as auth from "../../store/ducks/auth.duck";
import { push } from 'object-path';
import clsx from "clsx";
import { Link, Redirect } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from 'react-loader-advanced';
import Modal from './Modal';
import { Helmet } from 'react-helmet'
let count = 0;

library.add(fas)
const renderField = ({
    input,
    label,
    type,
    disabled,
    placeholder,
    isAsterisk,
    meta: { asyncValidating, touched, error }
}) => (
        <div className="formgroup">
            <div className="row">
                <label className="custom-label col-sm-2 text-right" style={{ color: "#3f4047", marginTop: 7 }}> {label}{isAsterisk && <sup style={{ color: "red" }}> *</sup>} </label>

                <div className="col-sm-6">
                    <div className={asyncValidating ? 'async-validating' : ''}>
                        <input {...input} type={type} placeholder={placeholder} disabled={disabled} className="form-control" />
                        {touched && error && <span className="error-msg text-danger">{error}</span>}

                    </div>
                </div>
            </div>
        </div>
    )
const renderTextAreaField = ({
    input,
    label,
    type,
    disabled,
    placeholder,
    meta: { asyncValidating, touched, error }
}) => (
        <div className="formgroup">
            <div className="row">
                <label className="custom-label col-sm-2 text-right" style={{ color: "#3f4047", marginTop: 7 }}> {label}</label>

                <div className="col-sm-6 ">
                    <div className={asyncValidating ? 'async-validating' : ''}>
                        <textarea {...input} type={type} placeholder={placeholder} rows="10" disabled={disabled} className="form-control" />
                        {touched && error && <span className="error-msg text-danger">{error}</span>}

                    </div>
                </div>
            </div>
        </div>
    )
const renderCheckboxField = ({
    input,
    label,
    type,
    checked,
    id,
    txtId,
    data,
    onClick,
    meta: { asyncValidating, touched, error }
}) => (
        <div className="formgroup render-checkbox ">
            <div className="col-sm-20">
                <div className={asyncValidating ? 'async-validating form-inline' : 'form-inline'}>
                    <input {...input} checked={checked || false} type={type} id={txtId} onClick={onClick} placeholder={label} value={data} className="form-control " style={{ height: 18, width: 18, color: "#575962" }} />
                    <label className="custom-label ml-3 checkboxText" style={{ color: "#575962" }} htmlFor={txtId}>{label}</label>
                </div>
            </div>
        </div>
    )

const validate = values => {
    const errors = {}
    const requiredFields = [
        'display_name',
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'This field is required'
        }
    })

    return errors
}

class EditRoles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            display_name: null,
            name: null,
            role: [],
            rolePermissions: [],
            isChecked: false,
            name: null,
            description: null,
            alert: null,
            display_name: null,
            isEditRole: false,
            isLoading: true,
            showModal: false,
            isInternalRole : false,
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(e) {
        // current array of options
        const options = this.state.rolePermissions
        let index

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            options.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            index = options.indexOf(+e.target.value)
            options.splice(index, 1)
        }
        // update the state with the new array of options
        this.setState({ rolePermissions: options })
        if (options.length == this.props.rolePermissionListResponse.length) {
            this.setState({ selectAll: true });
        }
        else {
            this.setState({ selectAll: false });
        }
    }

    selectAllPermissions = (e) => {
        let options = [];
        if (e.target.checked) {
            this.state.role.map(item => {
                options.push(+item.id)
            })
        }
        this.setState({ rolePermissions: options })
        if (options.length == this.props.rolePermissionListResponse.length) {
            this.setState({ selectAll: true });
        }
        else {
            this.setState({ selectAll: false });
        }
    }
    selectInternalRole = (e) =>{
        if (e.target.checked) {
            this.state.role.map(item => {
                this.setState({ isInternalRole: true });
            })
        }
        else{
            this.setState({ isInternalRole: false });
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        //Role Name
        if (!this.state.roleName) {
            formIsValid = false;
            errors["roleName"] = "Please enter name";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    onSubmit = (formProps) => {
        this.setState({ isEditRole: true });
        if(this.state.rolePermissions && this.state.rolePermissions.length > 0){
        this.props.saveRoleDetailRequest({
            name: formProps.name.trim(),
            description: formProps.description,
            Permission: this.state.rolePermissions.join(','),
            StatementType: "update",
            Id: formProps.id == "undefined" ? "0" : formProps.id.toString(),
            isBaa: "0",
            display_name: formProps.display_name.trim(),
            isInternalRole: this.state.isInternalRole,
        })
        } else {
            this.addRoleAlert("Please select atleast one permission.", 'error');
            this.setState({ isEditRole: false });

        }

    }

    componentDidMount() {
        this.props.fetchRolePermissionListRequest();
        this.props.fetchRoleDetailsRequest({ id: window.location.href.split("/").pop() });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saveRoleResponse) {
            if (nextProps.saveRoleResponse && nextProps.saveRoleResponse != this.props.saveRoleResponse) {
                if (nextProps.saveRoleResponse.success) {
                    this.setState({ isEditRole: false });
                    this.addRoleAlert(nextProps.saveRoleResponse.message, 'success');
                }
                else {
                    this.setState({ isEditRole: false });
                    this.addRoleAlert(nextProps.saveRoleResponse.message, 'error');
                }
            }
        }
        if (nextProps.roleDetailsResponseFail) {
            if (nextProps.roleDetailsResponseFail && nextProps.roleDetailsResponseFail != this.props.roleDetailsResponseFail) {
                if (nextProps.roleDetailsResponseFail.success == false) {
                    this.setState({isLoading: false});
                    this.addRoleAlert(nextProps.roleDetailsResponseFail.message, 'error');
                }
                else{
                    this.setState({isLoading: false});
                }
            }
        }
        if(count <= 4 )
        {
            this.setState({
                isInternalRole : nextProps.initialValues.isInternalRole,
            })
        }
        this.setState({

            'auth': {
                name: nextProps.initialValues.name,
                display_name: nextProps.initialValues.display_name,
                description: nextProps.initialValues.description,
                id: nextProps.initialValues.id,
            }
        });
        let options = [];
        if (nextProps.roleDetailsResponse && nextProps.roleDetailsResponse.length > 0 && nextProps.roleDetailsResponse != this.props.roleDetailsResponse) {
            nextProps.roleDetailsResponse.forEach(element => {
                options.push(element.permission_id)

            });
            if (options.length == this.props.rolePermissionListResponse.length) {
                this.setState({ selectAll: true });
            }
            else {
                this.setState({ selectAll: false });
            }
            this.setState({ rolePermissions: options })
        }
    }

    addRoleAlert(msg, type) {
        let getAlert = '';
        if (type == 'success') {
            getAlert = () => (
                <SweetAlert
                    success
                    title={msg}
                    onConfirm={() => this.hideAlert(true)}
                >
                </SweetAlert>
            );

        } else {
            getAlert = () => (
                <SweetAlert
                    error
                    title={msg}
                    onConfirm={() => this.hideAlert(false)}
                >
                </SweetAlert>
            );
        }

        this.setState({
            alert: getAlert(),
            showModal: ! this.state.showModal,
        });
    }
    hideAlert(isRedirected) {
        this.setState({
            alert: null,
            showModal: false,
        });
        if (isRedirected) {
            this.props.reset();
            this.setState({ redirect: true })
        }
    }

    render() {
        const spinner = <span className="loader"></span>;
        if (this.state.redirect) {
            return <Redirect to="/roles" />
        }

        const { handleSubmit, pristine, reset, submitting, formValues, change } = this.props;
        const { showModal } = this.state;
        this.state.role = this.props.rolePermissionListResponse;
        count++

        return (
            <>
        {
          showModal ? (
            <Modal>
                {this.state.alert}
            </Modal>
          ) : null
        }
        <Helmet>
                <title>Edit Role | Scorecard</title>
            </Helmet>

            <div className="main-content-body editRoles">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <MenuLeftNav isExpand={{ expand: "panel1", active: "dashboard" }}></MenuLeftNav>
                        </div>
                        <div className="col-lg-9 ">
                            <Loader show={this.state.isLoading} message={spinner}>
                                <div >
                                    <p className="main-heading">Manage Roles</p>
                                </div>
                                <div className="form-container">
                                    <div >
                                        <p className="heading">Edit Role</p>
                                    </div>
                                    <Divider />
                                    <form className="form" onSubmit={handleSubmit(this.onSubmit)} autoComplete="off">
                                        <div className="container mt-5">
                                            <div className="form-group" hidden>
                                                <Field
                                                    type="hidden"
                                                    margin="normal"
                                                    name="id"
                                                    component={renderField}
                                                />
                                            </div>
                                            <div className="form-group nameField">
                                                <Field
                                                    type="text"
                                                    margin="normal"
                                                    name="name"
                                                    label="Name"
                                                    placeholder="Please enter display name"
                                                    component={renderField}
                                                    isAsterisk="true"
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="form-group nameField">
                                                <Field
                                                    type="text"
                                                    margin="normal"
                                                    name="display_name"
                                                    label="Display Name"
                                                    placeholder="Please enter display name"
                                                    component={renderField}
                                                    isAsterisk="true"
                                                />
                                            </div>
                                            <div className="form-group descriptionField">
                                                <Field
                                                    type="textarea."
                                                    margin="normal"
                                                    name="description"
                                                    label="Description"
                                                    placeholder="Please enter description"
                                                    component={renderTextAreaField}
                                                />
                                            </div>
                                        </div>
                                        <div className="container checkbox" >
                                            <div className="row ml-1 adduser-checkbox-row">
                                                <p className="col-sm-2 text-right" style={{ color: "#3f4047" }}>Internal AdaptHealth Role</p>
                                                <div className="form-group nameField col-lg-3">
                                                    <Field
                                                        type="checkbox"
                                                        margin="normal"
                                                        name="isInternalRole"
                                                        txtId="isInternalRole"
                                                        checked={this.state.isInternalRole}
                                                        component={renderCheckboxField}
                                                        onChange={this.selectInternalRole.bind(this)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="container checkbox" >
                                            <div className="row">
                                                <p className="col-sm-2 text-right" style={{ color: "#3f4047" }}>Assign Permissions</p>
                                                <div className="form-group nameField col-lg-3">
                                                    <Field
                                                        type="checkbox"
                                                        margin="normal"
                                                        name="selectAll"
                                                        label="SelectAll"
                                                        txtId={"chk_permission_0"}
                                                        placeholder="Please enter display name"
                                                        component={renderCheckboxField}
                                                        checked={this.state.selectAll}
                                                        onChange={this.selectAllPermissions.bind(this)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="container" >
                                            <div className="row">
                                                <p className="col-sm-2 text-right" style={{ color: "#000", marginTop: 7 }}></p>

                                                <div className="container" style={{ marginLeft: '0px' }} >
                                                    <div className="row">

                                                        {this.state.role && this.state.role.length > 0 && this.state.role.map(item => {
                                                            const id = `chk_permission_${item.id}`;
                                                            return (
                                                                <div className="form-group nameField col-lg-4" key={item.id}>
                                                                    <Field
                                                                        type="checkbox"
                                                                        margin="normal"
                                                                        name={id}
                                                                        data={item.id}
                                                                        txtId={id}
                                                                        label={item.display_name}
                                                                        component={renderCheckboxField}
                                                                        checked={this.state.rolePermissions.some(element => element === item.id)}
                                                                        onChange={this.onChange.bind(this)}
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Divider />

                                        <center>
                                            <div className="mt-3">
                                                <div className="kt-login__actions">
                                                    <button style={{ width: 100, padding: 10 }}
                                                        id="kt_login_signin_submit"
                                                        type="submit"
                                                        disabled={pristine || submitting}
                                                        className={`btn btn-primary btn-elevate kt-login__btn-primary button-big mr-2 ${clsx(
                                                            {
                                                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light loaderWidth": this.state.isEditRole
                                                            }
                                                        )}`}
                                                    >
                                                        Update
                                        </button>
                                                    <Link style={{ width: 100 }}
                                                        to="/roles"
                                                        className={`btn btn-default btn-no`}>
                                                        Cancel
                                            </Link>
                                                </div>
                                            </div>
                                        </center>
                                    </form>
                                </div>
                            </Loader>
                        </div>
                    </div>
                </div>
            </div>
        </>
        )
    }


}
function mapStateToProps(state) {
    return {
        rolePermissionListResponse: state.auth.rolePermissionListResponse != undefined ? state.auth.rolePermissionListResponse.liModuleForRole : [],
        roleDetailsResponse: state.auth.roleDetailsResponse != undefined ? state.auth.roleDetailsResponse.liPermissionsByRoleID : [],
        roleDetailsResponseFail: state.auth.roleDetailsResponse != undefined ? state.auth.roleDetailsResponse : null,
        loading: state.auth.loading,
        saveRoleResponse: state.auth.saveRoleResponse,
        initialValues: {
            name: state.auth.roleDetailsResponse != undefined && state.auth.roleDetailsResponse.liRoleDetails != undefined ? state.auth.roleDetailsResponse.liRoleDetails[0].name : '',
            display_name: state.auth.roleDetailsResponse != undefined && state.auth.roleDetailsResponse.liRoleDetails != undefined ? state.auth.roleDetailsResponse.liRoleDetails[0].display_name : '',
            description: state.auth.roleDetailsResponse != undefined && state.auth.roleDetailsResponse.liRoleDetails != undefined ? state.auth.roleDetailsResponse.liRoleDetails[0].description : '',
            id: state.auth.roleDetailsResponse != undefined && state.auth.roleDetailsResponse.liRoleDetails != undefined ? state.auth.roleDetailsResponse.liRoleDetails[0].id : '',
            isInternalRole : state.auth.roleDetailsResponse != undefined && state.auth.roleDetailsResponse.liRoleDetails != undefined ? state.auth.roleDetailsResponse.liRoleDetails[0].isInternalRole : false,
        },

    }
}

EditRoles = reduxForm({
    form: 'EditRoles',
    validate,
    asyncValidate,
    enableReinitialize: true,
    destroyOnUnmount: false
})(EditRoles);

const mapDispatchToProps = (dispatch) => {
    return {
        fetchRolePermissionListRequest: () => dispatch(auth.actions.fetchRolePermissionListRequest()),
        fetchRoleDetailsRequest: ({
            id
        }) => dispatch(auth.actions.fetchRoleDetailsRequest({
            id
        })),
        saveRoleDetailRequest: ({
            name,
            description,
            Permission,
            StatementType,
            Id,
            isBaa,
            display_name,
            isInternalRole
        }) => dispatch(auth.actions.saveRoleDetailRequest({
            name,
            description,
            Permission,
            StatementType,
            Id,
            isBaa,
            display_name,
            isInternalRole
        }))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditRoles);
